import { AssociateDocumentResponse } from '../types';
import { medtechApi } from './index';

const issuesApi = {
  async associateDocument(
    company: number,
    eventId: number,
    stepId: number,
    ownerId?: number,
  ): Promise<AssociateDocumentResponse | undefined> {
    const url = `/quality-events/${company}/issues/${eventId}/steps/${stepId}/associate-content`;
    const response = ownerId ? await medtechApi.post(url, { owner_id: ownerId }) : await medtechApi.post(url);
    return AssociateDocumentResponse.parse(response.data);
  },
};
export default issuesApi;
